import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ILabelResidenceCertificateMutation } from './types';

export const usePostResidanceCertificate = (id: string) => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast(
    'usePostResidanceCertificate'
  );
  return useMutation<{}, DefaultError, ILabelResidenceCertificateMutation>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.add.loading', {
          what: i18next.t('label.certificates.what'),
        })
      );

      const formData = new FormData();

      formData.append('LabelId', id);
      formData.append(
        'ResidenceCertificateCountryCodeAlfa2',
        body.ResidenceCertificateCountryCodeAlfa2
      );
      formData.append(
        'ResidenceCertificateFile',
        body.ResidenceCertificateFile
      );
      formData.append(
        'ResidenceCertificateExpirationDate',
        body.ResidenceCertificateExpirationDate
      );

      const response = await apiClient({
        method: 'POST',
        url: 'Label/AddResidenceCertificate',
        body: formData,
        withContentType: false,
      });

      return responseHandler(response, {
        groupName: 'usePostResidanceCertificate',
        notFoundPath: '/label',
      });
    },
    onSuccess: data => {
      success(
        i18next.t('service-message.add.success', {
          what: i18next.t('label.certificates.what'),
        })
      );
    },
    onError: dismiss,
  });
};
